function init() {
    const sectionsAnchorset = document.querySelectorAll(".anchorsets-section");

    sectionsAnchorset.forEach(anchorsetElement => {
        // Get all sections that have an ID defined
        const sections = anchorsetElement.querySelectorAll(".content-item");
        const indicatorLine = anchorsetElement.querySelector(".actionbar-line-wrapper");
        const actionbarLink = anchorsetElement.querySelectorAll(".actionbar-link");

        actionbarLink.forEach((link, index) => {
            link.setAttribute("data-position", index);
        });
        const sectionSubNav = anchorsetElement.querySelector(".anchorset-dropdown-container");
        if (sectionSubNav) {
            const itemNav = sectionSubNav.querySelector(".navigation .title");
            const buttonSubNav = sectionSubNav.querySelector(".navigation .title .button-collapse");
            const dropdownList = sectionSubNav.querySelector(".dropdown-list-wrapper");
            const itemsDropdown = anchorsetElement.querySelectorAll(".item-collapse");

            itemNav.addEventListener("click", () => {
                dropdownList.classList.toggle("active");
                buttonSubNav.classList.toggle("button-collapse-active");
                const dropdownListTitle = itemNav
                    .querySelector(".dropdown-title")
                    .textContent.trim()
                    .toLowerCase();
                const dropdownListItemsText = dropdownList.querySelectorAll(".item-collapse");
                dropdownListItemsText.forEach(item => {
                    if (item.textContent.trim().toLowerCase() == dropdownListTitle) {
                        item.parentNode.parentNode.classList.add("hide");
                    } else {
                        item.parentNode.parentNode.classList.remove("hide");
                    }
                });
            });

            itemsDropdown.forEach(item => {
                item.addEventListener("click", () => {
                    dropdownList.classList.remove("active");
                    buttonSubNav.classList.remove("button-collapse-active");
                });
            });
        }
        // Add an event listener listening for scroll
        window.addEventListener("scroll", navHighlighter);

        function navHighlighter() {
            // Get current scroll position
            let scrollY = window.scrollY;
            if (anchorsetElement.querySelector(".dropdown-list-wrapper")) {
                if (anchorsetElement.querySelector(".dropdown-list-wrapper").classList.contains("active")) {
                    anchorsetElement.querySelector(".dropdown-list-wrapper").classList.remove("active");
                }
                // Activate first element by default
                const firstElement = anchorsetElement.querySelector(".content-item");
                if (scrollY < firstElement.offsetTop) {
                    anchorsetElement.querySelector(".actionbar-link").classList.add("active");
                    const firstItemMobileText = anchorsetElement.querySelector(".item-collapse").textContent.trim();
                    anchorsetElement.querySelector(".dropdown-title").textContent = firstItemMobileText;
                }
                // Now we loop through sections to get height, top and ID values for each
                sections.forEach(current => {
                    const sectionHeight = current.offsetHeight;
                    const sectionTop = current.offsetTop - 200;
                    const sectionId = current.getAttribute("data-id");
                    /*
                - If our current scroll position enters the space where current section on screen is, add .active class to corresponding navigation link, else remove it
                - To know which link needs an active class, we use sectionId variable we are getting while looping through sections as an selector
                */
                    const activeItem = anchorsetElement.querySelector(".actionbar-link.active");
                    if (activeItem) {
                        const offsetTop = activeItem.offsetTop;
                        const linkHeight = activeItem.offsetHeight;
                        const indicatorHeight = indicatorLine.offsetHeight;
                        const offset = offsetTop + linkHeight / 2 - indicatorHeight / 2;
                        indicatorLine.style.transform = `translateY(${offset}px)`;
                        anchorsetElement.querySelector(".dropdown-title").textContent = activeItem.textContent;
                    }

                    if (scrollY > sectionTop && scrollY <= sectionTop + sectionHeight) {
                        anchorsetElement.querySelector(`.actionbar-list a[href*='${sectionId}']`).classList.add("active");
                    } else {
                        if (scrollY < firstElement.offsetTop) {
                            anchorsetElement.querySelector(".actionbar-link").classList.add("active");
                        } else {
                            anchorsetElement.querySelector(`.actionbar-list a[href*='${sectionId}']`).classList.remove("active");
                        }
                    }
                });
            }
        }
    });
}

export default { init };
